// 百步梯中心（saas平台）接口
export default {

  register:'/Accounts',//注册 post

  confirmemail:'/Accounts/confirmemail',   //post  发送激活邮件

  PhoneNumber:'/Accounts/PhoneNumber',   //post  设置手机号并发送验证码

  ComfirmPhoneNumber:'/Accounts/ComfirmPhoneNumber',   //post  根据验证码激活手机号

  ForgotPassword:'/Accounts/ForgotPassword',   //post  忘记密码

  ComfirmPhoneNumberComplex:'/Accounts/ComfirmPhoneNumberComplex',   //post  根据验证码激活手机号(带公司信息)

  UnbindPhoneNumberCode:'/Accounts/UnbindPhoneNumberCode',   //post  发送解绑手机号验证码

  UnbindPhoneNumber:'/Accounts/UnbindPhoneNumber',   //put  解绑手机号

  profile:'/Accounts/profile',   //get  获取用户基本资料

  ChangePassword:'/Accounts/ChangePassword',   //post  修改密码

  ChangePhone:'/accounts/changePhone',   //post  修改手机号

  sendeCode:'/accounts/bind/email/code',   //post  发送邮箱验证吗

  changEmail:'/accounts/bind/email',   //post  发送变更绑定邮箱

  sendPhoneCode:'/accounts/phone/register/code', //post  发送手机验证码

  ckPhoneNumber:'/accounts/phone/exists', //post  发送手机验证码

  regPhone:'/accounts/phone/register', //post 手机号注册

  forgotPas:'/accounts/forgotPwd/code', //重置密码获取验证

  restPhEm:'/accounts/phone/reset',//手机邮箱重置密码

  ChangeNotificationPhone:'/tenants/notificationSettings/phone',   //post  修改通知设置-短信通知

  ChangeNotificationEmail:'/tenants/notificationSettings/email',   //post  修改通知设置-邮件

  tenantName:'/Accounts/tenantName',   //put  修改公司名称

  contactAddress:'/Accounts/contactAddress',   //put  修改联系地址

  fullName:'/Accounts/fullName',   //put  修改姓名

  Job:'/Accounts/Job',   //put  修改职务

  userGroups:'/userGroups',   // get查询分组列表 //post  新增分组  //delete  删除分组  //put  修改员工分组名称

  users:'/users',   //get  查询用户列表  用户有关api 都是用这个  //注册子账号 post

  test:'/Accounts/test',   //get

  test1:'/Accounts/test1',   //get

  menuitemsStart:'/serviceModules/',   //get  根据服务模块名称获取，改服务模块下的所有菜单————前半截

  menuitemsEnd:'/menuitems',//get  根据服务模块名称获取，改服务模块下的所有菜单————后半截

  MenuItems:'/MenuItems',//get  根据服务模块名称获取，改服务模块下的所有菜单

  ServiceModules:'/ServiceModules',   //get  得到所有的服务模块

  UploadFiles: '/Tenant/UploadFiles',  //  上传头像

  photo: '/Accounts/photo',  // 保存头像url  到后台

  permissions:'/Accounts/permissions',   //获取用户权限

  changePassword:'/Accounts/ChangeDefaultPassword',//修改密码

  UnbindExternalLogin:'/Accounts/UnbindExternalLogin',//解除微信一键登录绑定

  UnbindExternalLoginEmail:'/Accounts/UnbindExternalLoginEmail',//解除微信一键登录——发送邮箱验证码
}




// WEBPACK FOOTER //
// ./src/public/saasApi.js